import { readUsers } from '@directus/sdk';
import { useQuery } from '@tanstack/react-query';

import { PROMOTER_ROLE_ID } from '#constants/database-ids.ts';

import { directusClient } from '../../services/directusClient/directusClient.ts';

export const useUserListQuery = () =>
  useQuery({
    queryKey: ['users'],
    queryFn: async () => {
      return await directusClient.request(
        readUsers({
          filter: {
            role: PROMOTER_ROLE_ID,
          },
        }),
      );
    },
    retry: 0,
  });
